import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import SEO from "@/components/SEO";
import api from "@/lib/api";
import { container } from "@/lib/constants";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("working");
  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.get(`/public/unsubscribe?token=${token}`).then(() => setState("done")).catch(() => setState("error"));
  }, [token]);
  return (
    <PublicLayout>
      <SEO title="Unsubscribe" noindex />
      <section className={`${container} py-28`}>
        <GlassCard className="max-w-lg mx-auto p-10 text-center">
          {state === "working" && <p className="text-sm text-muted-foreground">Processing your request…</p>}
          {state === "done" && (<><h1 className="pdg-serif text-3xl text-foreground">Unsubscribed</h1><p className="mt-3 text-sm text-muted-foreground">You have been removed from non-essential emails. Critical account notices will still be sent.</p></>)}
          {state === "error" && (<><h1 className="pdg-serif text-3xl text-foreground">Link invalid</h1><p className="mt-3 text-sm text-muted-foreground">This unsubscribe link is invalid or has expired.</p></>)}
          <Link to="/" className="mt-6 inline-block text-sm text-[hsl(var(--pdg-gold))]">Return home</Link>
        </GlassCard>
      </section>
    </PublicLayout>
  );
}
